<template>
  <el-form
    :model="params"
    :rules="rules"
    hide-required-asterisk
    class="modern-login-form"
    ref="form"
  >
    <!-- 用户名输入框 -->
    <el-form-item prop="username" class="login-form-item">
      <div class="input-wrapper">
        <div class="input-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
          </svg>
        </div>
        <div class="input-divider"></div>
        <el-input
          v-model="params.username"
          placeholder="用户名输入"
          class="modern-input"
          @keypress.native.enter="submit()"
        />
      </div>
    </el-form-item>
    
    <!-- 密码输入框 -->
    <el-form-item prop="password" class="login-form-item">
      <div class="input-wrapper">
        <div class="input-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>
        <div class="input-divider"></div>
        <el-input
          v-model="params.password"
          :type="showPassword ? 'text' : 'password'"
          placeholder="密码"
          class="modern-input"
          @keypress.native.enter="submit()"
        />
        <div class="password-toggle" @click="showPassword = !showPassword">
          <svg v-if="!showPassword" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
          </svg>
          <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
            <line x1="1" y1="1" x2="23" y2="23"/>
          </svg>
        </div>
      </div>
    </el-form-item>
    
    <!-- 登录按钮 -->
    <el-form-item class="login-form-item login-btn-item">
      <el-button
        type="primary"
        class="login-submit-btn"
        :loading="$loadings.loading"
        @click.stop="submit()"
      >登录</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import Vue from 'vue'
import md5 from 'js-md5'
import { signIn } from 'index/api'
import { UPDATE_TOKEN } from 'store/mutation-types'
export default {
  name: 'LoginModule',

  created () {
    const username = localStorage.getItem('username') || ''
    const password = localStorage.getItem('password') || ''
    Object.assign(this.params, {
      username,
      password
    })
    if (username && password) {
      this.remember = 1
    }
  },

  data () {
    return {
      remember: 0,
      showPassword: false,
      active: 'login',
      params: {
        username: '',
        password: ''
      },
      rules: {
        username: [
          {
            required: true,
            message: '请输入用户名'
          }
        ],
        password: [
          {
            required: true,
            message: '请输入密码'
          },
          {
            validator: (rule, value, callback) => {
              return this.submit(callback)
            },
            trigger: 'submit'
          }
        ]
      }
    }
  },

  methods: {
    redirectToModule () {
      this.$emit('redirectToModule', 'forgot')
    },
    createObjectURL (object) {
      return (window.URL) ? window.URL.createObjectURL(object) : window.webkitURL.createObjectURL(object)
    },
    submit (callback) {
      if (callback) {
        this.$refs.form.validateField('username', err => {
          if (err) return callback(new Error(err))
          this.submitLogin(this.params, callback)
        })
      } else {
        this.$refs.form.validateField('username', err => {
          if (!err) {
            this.$refs.form.validateField('password')
          }
        })
      }
    },
    submitLogin (params, callback) {
      const { password, username } = params
      signIn({
        ...params,
        password: md5(md5(this.params.password))
      }).then(data => {
        if (this.remember) {
          localStorage.setItem('ccurrentId', '1')
          localStorage.setItem('username', username)
          localStorage.setItem('password', password)
        } else {
          localStorage.removeItem('username')
          localStorage.removeItem('password')
        }
        let token = data.data.accessToken
        localStorage.setItem('ACCESS_TOKEN', token, 7 * 24 * 60 * 60 * 1000)
        this.$store.commit(UPDATE_TOKEN, token)
        
        // 设置刚登录标记，供路由守卫判断跳转目标
        sessionStorage.setItem('JUST_LOGGED_IN', '1')
        
        // 登录成功后跳转首页，路由守卫会根据permissions中的project字段判断实际跳转目标
        let { redirect } = this.$route.query
        this.$router.push(redirect || '/')
      }).catch(err => {
        const { data } = err
        let { message = '登录失败' } = data || {}
        if (err && typeof err.message === 'string') {
          message = err.message
        }
        callback && callback(new Error(message))
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/* 表单整体样式 */
.modern-login-form {
  width: 100%;
}

/* 表单项 */
.login-form-item {
  margin-bottom: 24px;
  
  :deep(.el-form-item__error) {
    padding-top: 6px;
    font-size: 12px;
  }
}

/* 输入框包装器 */
.input-wrapper {
  display: flex;
  align-items: center;
  background: #f8f9fc;
  border-radius: 8px;
  padding: 0 16px;
  height: 50px;
  border: 1px solid #e8ecf3;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #d0d7e3;
  }
  
  &:focus-within {
    border-color: #1476ff;
    background: white;
    box-shadow: 0 0 0 3px rgba(20, 118, 255, 0.1);
  }
}

/* 输入框图标 */
.input-icon {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
  color: #a0aec0;
  
  svg {
    width: 100%;
    height: 100%;
  }
}

/* 分隔线 */
.input-divider {
  width: 1px;
  height: 20px;
  background: #d0d7e3;
  margin: 0 14px;
  flex-shrink: 0;
}

/* 现代化输入框 */
.modern-input {
  flex: 1;
  
  :deep(.el-input__inner) {
    border: none !important;
    background: transparent !important;
    padding: 0 !important;
    height: 48px;
    line-height: 48px;
    font-size: 15px;
    color: #2d3748;
    
    &::placeholder {
      color: #a0aec0;
    }
  }
}

/* 密码显示切换 */
.password-toggle {
  width: 22px;
  height: 22px;
  cursor: pointer;
  color: #a0aec0;
  flex-shrink: 0;
  margin-left: 10px;
  transition: color 0.2s ease;
  
  &:hover {
    color: #1476ff;
  }
  
  svg {
    width: 100%;
    height: 100%;
  }
}

/* 登录按钮容器 */
.login-btn-item {
  margin-top: 35px;
  margin-bottom: 0;
}

/* 登录按钮 */
.login-submit-btn {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 2px;
  border-radius: 8px !important;
  background: #1476ff !important;
  border: none !important;
  box-shadow: 0 8px 25px rgba(20, 118, 255, 0.3);
  transition: all 0.3s ease;
  
  &:hover {
    background: rgba(20, 118, 255, 0.9) !important;
    transform: translateY(-2px);
    box-shadow: 0 12px 30px rgba(20, 118, 255, 0.4);
  }
  
  &:active {
    transform: translateY(0);
    box-shadow: 0 5px 15px rgba(20, 118, 255, 0.3);
  }
}
</style>
